module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.html.js
 ** module id = 550
 ** module chunks = 0
 **/